import { Button, Col, FormGroup, Label, Row, Table } from "reactstrap";
import HeaderAdmin from "../../../components/HeaderAdmin/HeaderAdmin";
import DatePicker from "react-datepicker";
import { ptBR } from "date-fns/locale";
import { useContext, useState } from "react";
import api from "../../../services/axiosConfig";
import { Context } from "../../../hooks/useAuthContext";
import NovoDolarModal from "./NovoDolarModal/NovoDolarModal";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
import './styles.css'
import { Link } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";

function Dolar() {
  const { exibirLogs } = useContext(Context);
  const [dataDolar, setDataDolar] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [dolares, setDolares] = useState([]);
  const [dolarEmEdicao, setDolarEmEdicao] = useState(null);

  async function fetchData() {
    try {
      setLoading(true);

      const params = {};

      if (dataDolar) {
        params.createdAt = dataDolar;
      }

      const response = await api.get("/dolar", { params });
      setDolares(response.data || []);
    } catch (error) {
      exibirLogs && console.error("Erro ao buscar dólares:", error);
    } finally {
      setLoading(false);
    }
  }

  function handleDataDolarChange(date) {
    setDataDolar(date);
  }

  async function handleDelete(id) {
    const result = await Swal.fire({
      title: "Tem certeza?",
      text: "Você não poderá reverter esta ação!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      confirmButtonText: "Sim, excluir!",
    });

    if (result.isConfirmed) {
      try {
        await api.delete(`/dolar/${id}`);
        toast.success("Valor do Dólar excluído com sucesso!");
        fetchData();
      } catch (error) {
        toast.error(error.message || "Erro ao excluir o valor do Dólar.");
      }
    }
  }
  
  const toggleModal = () => setIsModalOpen(!isModalOpen);

  const handleAbrirModalNovo = () => {
    setDolarEmEdicao(null); 
    toggleModal();
  };

  const handleAbrirModalEdicao = (dolar) => {
    setDolarEmEdicao(dolar); 
    toggleModal();
  };

  return (
    <div>
      <HeaderAdmin />
      <div className="infoPage">
        <span>
          <Link to={'/'} style={{ textDecoration: 'none', color: '#000'}}>
            <FaArrowLeft size={16} /> Dolar
          </Link> 
        </span>
      </div>

      <div className="miniWrapper" style={{ marginTop: 20 }}>
        <Row style={{ display: "flex", justifyContent: "space-between" }}>

          <Col md={4} sm={3} xs={4}>
            <FormGroup className="filterGroup">
              <Label for="dataDolar">Data do dólar</Label>
              <DatePicker
                selected={dataDolar}
                onChange={handleDataDolarChange}
                dateFormat="MM/yyyy"
                showMonthYearPicker
                locale={ptBR}
                className="dateInputRelatorio form-control"
                placeholderText="Selecione mês e ano do dólar cadastrado"
                id="dataDolar"
                autoComplete="off"
              />
            </FormGroup>
            
          </Col>

          <Col md={2} sm={3} xs={4}>
          {dataDolar &&  (
              <FormGroup className="filterGroup">
                <Label>Ações</Label>
                <Button color="danger" onClick={() => setDataDolar(null)}>
                  Limpar data
                </Button>
              </FormGroup>
            )}
          </Col>

          <Col md={6} sm={3} xs={8} className="areaBotoesInfo">
            
            <FormGroup className="filterGroup">
              <Label>Ações</Label>
              <Button color="success" onClick={fetchData}>
                {dataDolar ? "Buscar" : "Buscar todos"}
              </Button>
            </FormGroup>

            <FormGroup className="filterGroup">
              <Label>Ações</Label>
              <Button color="secondary" onClick={handleAbrirModalNovo}>
                Cadastrar Dólar
              </Button>
            </FormGroup>
          </Col>

        </Row>

        <Table striped>
          <thead>
            <tr>
              <th>Valor do dólar</th>
              <th>Mês referente ao trabalho</th>
              <th>Mês do dólar</th>
              <th>Ações</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan={6} style={{ textAlign: "center" }}>
                  Carregando...
                </td>
              </tr>
            ) : dolares.length === 0 ? (
              <tr>
                <td colSpan={6} style={{ textAlign: "center" }}>
                  Não há dados
                </td>
              </tr>
            ) : (
              dolares.map((dolar) => ( 
                <tr key={dolar._id}>
                  <td>{Number(dolar.value).toFixed(2)}</td>
                  <td>{dolar.dateRef}</td>
                  <td>{dolar.createdAt}</td>
                  <td style={{ display: "flex", gap: "5px" }}> 
                    <Button
                      color="primary"
                      onClick={() => handleAbrirModalEdicao(dolar)}
                      style={{ width: "50%" }}
                    >
                      Editar
                    </Button>
                    <Button
                      color="danger"
                      onClick={() => handleDelete(dolar._id)}
                      style={{ width: "50%" }}
                    >
                      Excluir
                    </Button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </Table>
      </div>

      <NovoDolarModal 
        isOpen={isModalOpen} 
        toggle={toggleModal} 
        onSave={fetchData}
        dolarParaEditar={dolarEmEdicao}
      />
    </div>
  );
}

export default Dolar;